/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Enpp.Overview <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 8.4.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 22.4.2022                                                *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.EnppOverview", $.common.VisualBase, {
    data: null,
    fullInformation: null,
    date: null,
    periodWidthDefault: 220,
    bInit: false,
    bShowBaseline: false,
    pieChartHeight: 110,
    digitNumber: 2,
    digitNumberPercent:2,
    _create: function () {
        var me = this;
        try {

            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 331;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //inits the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {


            if (me.element.find("#div-top-menu #ddl-list option").length == 0) { return false; }

            me.showMessage("", false);
            me.content = me.fnd("#div-content");




            //we fill the entry list option box
            var tmp = me.element.find("#div-top-menu #ddl-list").clone().css("width", "100%").show();
            me.element.find("#div-top-menu #ddl-list").replaceWith($("<div>", { "class": "select-list-box vc-grid-1col  vc-grid-margin-right" }));
            me.element.find("#div-top-menu .select-list-box").vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.list, clickable: false, isList: true, content: tmp }]
            });


            if (me.element.find("#div-top-menu #ddl-list option").length < 2) {
                me.element.find("#div-top-menu .select-list-box").hide();
            }
            me._fetchFullInformation();

        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            if (me.element.find("#div-top-menu #ddl-list option").length == 0) {

                return false;
            }


            me.element.on("change", "#ddl-list", function () { me._fetchFullInformation() });

            me.element.off("click").on("click", "#div-btn-reload", function () { me._fetch() });

            me.element.on("click", ".icon-sublist", function (e) { me._toggleDetails($(e.target)) });


        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },

    _toggleDetails: function (obj) {
        /// <summary>
        /// This function shows/hides the details for one single row
        /// </summary>
        var me = this;
        try {
            var counter = obj.data("counter");
            if (obj.hasClass("fa-plus-square")) {
                me.fnd("#div-list .sub.area" + counter).show();
                obj.removeClass("fa-plus-square").addClass("fa-minus-square");
            } else {
                me.fnd("#div-list .sub.area" + counter).hide();
                obj.removeClass("fa-minus-square").addClass("fa-plus-square");
            }


        } catch (e) { me.writeError('_toggleDetails', e); }
    },

    _fetchFullInformation: function () {
        /// <summary>
        /// This function fetches all required information for one single enpp
        /// </summary>
        var me = this;
        var param;
        try {

            param = { TypeId: 2, Id: me.fnd("#ddl-list").val() };


            me.getData(param, function (result) {
                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }


                me.fullInformation = result;
                me.bShowBaseline = me.fullInformation.Entry.Settings.Baseline.Type > 0;

                me.content.html("");
                me._generateLoggerList();
                me._generateMenuItems();

                if (!me.bInit) {
                    me._fetch();
                    me.bInit = false;
                }

                return true;
            });

        } catch (e) { me.writeError('_fetchFullInformation', e); return false; }
        return true;
    },

    _generateLoggerList: function (dtt) {
        /// <summary>
        /// This function generates the logger list as selectable list
        /// </summary>
        var me = this;
        try {

            var list = me.fnd("#div-logger").html("");

            if (me.fullInformation.LoggerList === null) {
                list.html($("<br>"));
                list.append($("<div>", { class: "note" }).html(me.resources.noEntriesExist));
                return false;
            }
            if (me.fullInformation.LoggerList.length == 0) {
                list.html($("<br>"));
                list.append($("<div>", { class: "note" }).html(me.resources.noEntriesExist));
                return false;
            }

            $.each(me.fullInformation.LoggerList, function (i, logger) {
                list.append($("<div>").data("id", logger.Id).addClass("button-toggle button-toggle-active vc-grid-margin-right ").html(logger.Name));
            });
            list.find(".button-toggle").button();
            //add a click handler
            list.find(".button-toggle").off("click").on("click", function () {
                if ($(this).hasClass("button-toggle-active")) {
                    $(this).removeClass("button-toggle-active")
                } else {
                    $(this).addClass("button-toggle-active")
                }
            });
            me.fnd("#div-project-selection").removeClass("showMap");
            me.fnd("#div-map").html("");
            //if we have to show the landmap ...
            if (me.fullInformation.Entry.Settings.ProjectListType == 1) {
                me.fnd("#div-project-selection").addClass("showMap");

                var container = me.getRandomIDContainerObj("div-map", true);
                container.obj.height(me.fnd("#div-map").height());
                container.obj.width(parseInt(me.element.width() - me.fnd("#div-logger").width() - 10));
                me.fnd("#div-map").html(container.obj);
                container.obj.EnppMap({ invokeType: "addVisualBase", parameter: { Id: me.fnd("#ddl-list").val() } });
            }

            //we have to reset the content height
            me.content.height(parseInt(me.visual.height() -
                me.fnd("#div-top-menu").outerHeight() - me.fnd("#div-project-selection").outerHeight() - 25));

            return true;
        } catch (e) {
            me.writeError('_generateLoggerList', e); return false;
        }

    },

    _generateMenuItems: function (dtt) {
        /// <summary>
        /// This function recreates the top menu list with the option boxes
        /// nothing too complicated
        /// </summary>
        var me = this;
        var list;
        try {




            //we init the vcDate selection ... and start the showChart for the first time
             //if we start, we init a new vcDateBox
            if (me.fnd("#div-date").html().length == 0) {
                me.fnd("#div-date").vcDateBox({
                    mode: "Single", align: "center", interval: me.fullInformation.Entry.Settings.IntervalType, langID: me.settings.userLangIDForCulture, callback: function (obj) {
                        me.date = obj.singleDate;
                    }
                });
            } else {
                //otherwise we have to reset everything
                me.fnd("#div-date .vc-date").vcDate("destroy").html("<div class='vc-date'></div>");
                me.fnd("#div-date .vc-date").vcDate({
                    mode: "Single", align: "center", interval: me.fullInformation.Entry.Settings.IntervalType, langID: me.settings.userLangIDForCulture, callback: function (obj) {
                        me.date = obj.singleDate;
                    }
                });
            }
           
         
            list = me.fnd("#div-menu-items").html("");

            var ddlComparison = $("<select>").attr("id", "ddl-comparison-periods").addClass("ddl input ").css("margin-left", "33%");
            for (var i = 0; i < me.specific.maxComparisonPeriods; i++) {
                ddlComparison.append($("<option>").attr("value", i).text(i));
            }
            ddlComparison.val(me.fullInformation.Entry.Settings.ComparisonPeriods);
            var divComp = $("<div>").addClass("sub ddl-comparison vc-grid-margin-right").vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.comparisonPeriod, clickable: false, isList: true, content: ddlComparison  }]
            });
            divComp.find(".content-item").append(" " + me.specific.resources.periods);
            list.append(divComp);

            var ddlDataType = $("<select>").attr("id", "ddl-data-type").css("width", "100%").addClass("ddl input ");
            ddlDataType.append($("<option>").attr("value", 0).text(me.specific.resources.values));
            ddlDataType.append($("<option>").attr("value", 1).text(me.specific.resources.price));
            ddlDataType.append($("<option>").attr("value", 2).text(me.specific.resources.co2));

            var dt = $("<div>").addClass("sub vc-grid-margin-right").vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.datatypes, clickable: false, isList: true, content: ddlDataType }]
            });

            list.append(dt);


            var ddlKpi = $("<select>").attr("id", "ddl-kpi-list").css("width", "100%").addClass("ddl input");
            ddlKpi.append($("<option>").attr("value", -1).text(me.specific.resources.noSelection));

            $.each(me.fullInformation.Entry.KpiList, function (i, kpi) {
                ddlKpi.append($("<option>").attr("value", kpi.Id).text(kpi.Name + " [" + kpi.Unit + "]"));
            });

           var kpi = $("<div>").addClass("sub").vcOptionBox({
               caption: me.resources.selection, items: [{ button: me.specific.resources.metaTypes, clickable: false, isList: true, content: ddlKpi }]
            });

            list.append(kpi);
            if (me.fullInformation.Entry.KpiList.length == 0) { kpi.hide() }
            return true;
        } catch (e) {
            me.writeError('_generateMenuItems', e); return false;
        }

    },

    _fetch: function () {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        var param;
        try {

            var loggers = [];
            //get all selected loggers
            me.fnd("#div-logger .button-toggle-active").each(function () {
                loggers.push(($(this).data("id")));
            });

            if (loggers.length == 0) {
                me.content.html($("<div>", { class: "note" }).html(me.resources.noEntriesExist));
                return false;
            }

            me.content.html(me.getLoadingIcon());

            param = {
                TypeId: 1, Id: me.fnd("#ddl-list").val(), Interval: me.fullInformation.Entry.Settings.IntervalType, DataTypeID: me.fnd("#ddl-data-type").val(), LoggerIds: loggers, startDate: me.date,
                comparisonPeriods: me.fnd("#ddl-comparison-periods").val(),
                KpiId: me.fnd("#ddl-kpi-list").val()
            };

            me.getData(param, function (result) {
                //check response content
               if (result == null) {
                   me.showMessage(me.resources.err_loadData, true);
                   return true;
               }

                me.data = result;
                //generate the list
                me._generateList();
                return true;
            });

        } catch (e) { me.writeError('_fetch', e); return false;}
        return true;
    },

    _generateList: function (dtt) {
        /// <summary>
        /// This function generates a list from the enpp data list
        /// nothing too complicated
        /// </summary>
        var me = this;
        var wrapper;
        try {

            //we round to 0 digits for yearly lists
            if (me.fullInformation.Entry.Settings.IntervalType == 5) {
                me.digitNumber = 0;
                me.digitNumberPercent = 1;
            } else {
                me.digitNumber = 2;
                me.digitNumberPercent = 2;
            }

            var list = $("<div>").attr("id", "div-list").addClass("vc-list").height(me.content.height()-20);
            me.fnd("#div-content").html(list);
         
            if (me.data === null) {
                list.html($("<div>", {class:"note"}).html(me.resources.noEntriesExist));
                return false;
            }
            if (me.data.Areas.length > 0) {
            } else {
                list.html($("<div>", { class: "note" }).html(me.resources.noEntriesExist));
                return false;
            }
            //if we got some validation information we write it on top of the list
            if (me.data.Validation.length > 0) {
                var infos = $("<div>", { class: "error vc-grid-margin-bottom" }).html("");
                $.each(me.data.Validation, function (i, entry) {
                    infos.append(entry + "<br/>");
                });
                list.append(infos);
             }

            //first, we decide how much width we use for one single period
            if (me.bShowBaseline) {
                me.periodWidth = me.periodWidthDefault;
                me.periodWidthValues = parseInt(me.periodWidthDefault * 0.68);
                me.periodWidthChanges = parseInt(me.periodWidthDefault * 0.32);
            } else {
                me.periodWidth = parseInt(me.periodWidthDefault * 0.7);
                me.periodWidthValues = me.periodWidth;
                me.periodWidthChanges =0;
            }
            //if the list is too wide, we have to reset the divs widths
            var maxWidth = (me.periodWidth * me.data.Areas[0].Caption.Periods.length) + 440;
            if (me.bShowBaseline) maxWidth += 150;
            if (list.width() < maxWidth) list.width(maxWidth);

          
            //if we use baselines, we add an additional caption for it
            if (me.bShowBaseline) {
                list.append($("<div>", { "class": "baseline vc-list-header-simple color-bg-secondary" }).html(me.specific.resources.baseline));
            }
            var counter = 0;
            //we iterate all areas
            $.each(me.data.Areas, function (i, area) {
                
                wrapper = $("<div>", { "class": "wrapper vc-grid-margin-bottom" });
                //we write the caption
                me._generateListCaption(wrapper, area.Caption);
                //rows
              
                $.each(area.Rows, function (k, row) {
                    me._generateListRow(wrapper,counter, row, "");
                    counter += 1;
                });
                //sum
                me._generateListRow(wrapper,-1,area.Sum, "alt");
              
                list.append(wrapper);
            });

            return true;
        } catch (e) {
            me.writeError('_generateList', e); return false;
        }

    },

    _generateListCaption: function (wrapper, caption) {
        /// <summary>
        /// This function generates the caption row for one area
        /// </summary>
        var me = this;
        try {

            var header = $("<div>", { "class": "vc-list-header color-bg-secondary" });
            var item = $("<div>", { "class": "vc-list-item" });

            item.append($("<div>").addClass("vc-list-col vc-list-col-element name").html(caption.Name));

            if (me.bShowBaseline) item.append($("<div>").addClass("vc-list-col vc-list-col-element baseline r").html(caption.Baseline));

            $.each(caption.Periods, function (j, period) {
                item.append($("<div>").addClass("vc-list-col vc-list-col-element r").css("width", me.periodWidthValues).html(period));
                item.append($("<div>").addClass("vc-list-col vc-list-col-element ").css("width", me.periodWidthChanges).html("<br/>"));
              
            });
            header.append(item);
            wrapper.append(header);

            return true;
        } catch (e) {
            me.writeError('_generateCaption', e); return false;
        }

    },

    _generateListRow: function (wrapper,counter, row, cssClass) {
        /// <summary>
        /// This function generates one single rows of an area
        /// </summary>
        var me = this;
        var item, name;
        var val;
        try {
            item = $("<div>", { "class": "vc-list-item area" + counter + " " + cssClass });

            if (row.Valid == false) { item.addClass("err"); }
            name = row.Name + " [" + row.Unit + "]";
            if (cssClass == "") {
                name = "<i data-counter='" + counter + "' class='vc-list-icon icon-sublist fas fa-plus-square color-font-secondary'></i> " + name;
            }
            item.append($("<div>").addClass("vc-list-col vc-list-col-element name").html(name));

            //we write the baseline column
            if (me.bShowBaseline) {
                val = row.Baseline.Value.toLocaleString("de-de", { minimumFractionDigits: me.digitNumber, maximumFractionDigits: me.digitNumber });

              


                if (row.Baseline.Status > 0) val += " " + me.specific.resources.icon_invalid;
                item.append($("<div>").addClass("vc-list-col vc-list-col-element baseline r").html(val));
            }
             //we iterate the periods
            $.each(row.Periods, function (l, period) {
                //console.info(period.Value + "  " + isNaN(period.Value) + "   " + isFinite(period.Value));
                if (isNaN(period.Value) || isFinite(period.Value) == false) {
                    val = "-";
                } else {
                    val = period.Value.toLocaleString("de-de", { minimumFractionDigits: me.digitNumber, maximumFractionDigits: me.digitNumber });
                    if (period.Status > 0) val += " " + me.specific.resources.icon_invalid;
                }
                item.append($("<div>").addClass("vc-list-col vc-list-col-element r").css("width", parseInt(me.periodWidthValues)).html(val));


                //if we use basellines, we add the changeToBaseline column
                if (me.bShowBaseline) {

                    if (period.Value == 0 && period.ChangeToBaseline == 0) {
                        val = "-";
                    } else {

                        val = period.ChangeToBaseline.toLocaleString("de-de", { minimumFractionDigits: me.digitNumberPercent, maximumFractionDigits: me.digitNumberPercent }) + " %";
                        if (isNaN(period.ChangeToBaseline) || isFinite(period.ChangeToBaseline) == false) {
                            val = "-";
                        } else {
                            val = period.ChangeToBaseline.toLocaleString("de-de", { minimumFractionDigits: me.digitNumberPercent,maximumFractionDigits: me.digitNumberPercent }) + " %";
                        }
                    }

              
                    item.append($("<div>").addClass("vc-list-col vc-list-col-element r").css("width", parseInt(me.periodWidthChanges)).html(val));
                }
            });

            wrapper.append(item);

            //we generate the same list for each sublist
            $.each(row.SubList, function (k, row) {
                me._generateListRow(wrapper, counter, row,  "sub sublist");
            });

            me._generateSublistPieCharts(wrapper,counter, row.SubList);
            me._generateSublistLineCharts(wrapper,counter,  row.SubList);

            return true;
        } catch (e) {
            me.writeError('_generateListRow', e); return false;
        }

    },

    _generateSublistPieCharts: function (wrapper,counter, sublist) {
        /// <summary>
        /// This function generates a list of pie charts for each period and all sub signals
        /// </summary>
        var me = this;
        var item, series, pos =64, top=30;
        try {
          
            if (sublist.length > 0) {

                var periods = sublist[0].Periods.length;
                if (periods == 0) { return true };

                //if the list is too wide, we have to reset the divs widths
                var maxWidth = me.fnd("#div-list").width()-440;
             
                item = $("<div>", { "class": "vc-list-item area" + counter + " sub " });
                item.append($("<div>").addClass("vc-list-col vc-list-col-element name").html("<br/>"));
                var chart = $("<div>").addClass("vc-list-col vc-list-col-element pie-chart").width(maxWidth);
               
                var seriesList = [];
                if (me.bShowBaseline) {
                    series = { type: 'pie',name:'', data: [],
                        center: [pos, top], size: me.pieChartHeight,
                        showInLegend: false, dataLabels: { enabled: false }
                    }
                    $.each(sublist, function (k, row) {
                        series.data.push({ name: { n: row.Name, u: row.Unit, dt: me.data.Areas[0].Caption.Baseline }, y: row.Baseline.Value });
                    });
                    seriesList.push(series);
                } else {
                    //we have to ge left as we have no baseline
                    pos = pos * -1;
                }
                for (var i = 0; i < periods; i++) {
                    pos += (me.periodWidth);
                    series = {type: 'pie', name: '', data: [],
                        center: [pos, top], size: me.pieChartHeight,
                        showInLegend: false, dataLabels: { enabled: false }
                    }
                    $.each(sublist, function (k, row) {
                        series.data.push({ name: { n: row.Name, u: row.Unit, dt: me.data.Areas[0].Caption.Periods[i]  }, y: row.Periods[i].Value  });
                    });
                    seriesList.push(series);
                }
                var options = {
                    tooltip: { formatter: function () { return this.key.n + '<br/><u>' + this.key.dt + '</u><br/><b>' + Highcharts.numberFormat(this.y, me.specific.digitNumber, ',', '.') + '</b> [' + this.key.u + '] (' + Highcharts.numberFormat(this.percentage, me.specific.digitNumber, ',', '.') + ' %)' }} ,
                  
                    series: seriesList
                };
                var ro = new RampOptions();
                chart.highcharts($.extend({}, ro.getTheme(), options));
                item.append(chart);
                wrapper.append(item);

            }

            return true;
        } catch (e) {
            me.writeError('_generateSublistPieCharts', e); return false;
        }

    },

    _generateSublistLineCharts: function (wrapper,counter, sublist) {
        /// <summary>
        /// This function generates a list of line chart for each period and all sub signals
        /// </summary>
        var me = this;
        var item, series;
        try {

            if (sublist.length > 0) {

                var periods = sublist[0].Periods.length;
                if (periods == 0) { return true };

                //if the list is too wide, we have to reset the divs widths
                var maxWidth = me.fnd("#div-list").width() - 440;

                item = $("<div>", { "class": "vc-list-item area" + counter + " sub" });
                item.append($("<div>").addClass("vc-list-col vc-list-col-element name").html("<br/>"));
                var chart = $("<div>").addClass("vc-list-col vc-list-col-element line-chart").width(maxWidth + 120).css("margin-left","-120px");

                var seriesList = [];
                $.each(sublist, function (k, row) {
                    series = { name: { n: row.Name, u: row.Unit, dt: me.data.Areas[0].Caption.Periods[i] }, data: [] }
                    if (me.bShowBaseline) {
                        series.data.push([me.data.Areas[0].Caption.Baseline, row.Baseline.Value ] );
                    }
                    $.each(row.Periods, function (k, p) {
                        series.data.push({ name: { n: row.Name, u: row.Unit, dt: me.data.Areas[0].Caption.Periods[i] }, y: p.Value });
                    });
                    seriesList.push(series);
                });
               
                var ro = new RampOptions();
                var options = ro.getTheme();
                options.chart.height = 200;
                options.chart.marginLeft = 100;
               
                options.chart.width = (periods * me.periodWidth) + 170;
                if (me.bShowBaseline) {
                    options.chart.width += 150;
                }
                options.series = seriesList;                                                                
                options.xAxis.title = { text: '' };
                
                options.xAxis.categories = [];
                if (me.bShowBaseline) {
                    options.xAxis.categories.push(me.data.Areas[0].Caption.Baseline);
                }
                $.each(me.data.Areas[0].Caption.Periods, function (k, p) {
                    options.xAxis.categories.push(p);
                });
               
                options.yAxis.title = { text: '' };
                options.yAxis.labels= { formatter : function () { return Highcharts.numberFormat(this.value, me.specific.digitNumber, ',', '.') } };
                options.plotOptions.spline.marker = { enabled: false };
                options.tooltip.formatter = function () {  return this.series.name.n + '<br/><u>' + this.x + '</u><br/><b>' + Highcharts.numberFormat(this.y, me.specific.digitNumber, ',', '.') + '</b> [' + this.series.name.u + ']' };
                options.legend.margin = 20;
                options.legend.labelFormatter = function () { return this.name.n + " [" + this.name.u + "]"; };
                chart.highcharts(options);
                item.append(chart);
                wrapper.append(item);

            }

            return true;
        } catch (e) {
            me.writeError('_generateSublistLineCharts', e); return false;
        }

    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-top-menu,#div-project-selection, #div-content").hide();
            }
            return true;
        } catch (e) {
            me.writeError('_setDirty', e); return false;
        }
    }


});

